import { filterObjectStore, queryFilter } from 'Redux/Query';

export const getDocuments = (state, filter = null) => {
    if(filter === null) {
        filter = queryFilter({sorting: { by: 'createdAt', order: 'DESC' }})
    }

    return filterObjectStore(state.document.documents.entries, filter);
};
